import { useTranslation } from 'react-i18next'

import { useArabicSessionLanguage } from '../../global/context/SessionSettingsContext'
import { NavigationArrowLeftIcon } from '../../icons/NavigationArrowLeftIcon'
import { NavigationArrowRightIcon } from '../../icons/NavigationArrowRightIcon'
import { Tooltip } from '../../ui/Popups/Tooltip/Tooltip'

import styles from './LoyaltyPage.module.scss'

interface Props {
  onScroll: (direction: 'left' | 'right') => void
  stopScrolling: () => void
}

export const LoyaltySliderControls = ({ onScroll, stopScrolling }: Props): JSX.Element => {
  const isArabic = useArabicSessionLanguage()
  const { t } = useTranslation()

  return (
    <nav className={styles.sliderControls} aria-label='Loyalty tier slider controls'>
      <button
        type='button'
        onMouseDown={() => onScroll(!isArabic ? 'left' : 'right')}
        onMouseUp={stopScrolling}
        onMouseLeave={stopScrolling}
        className={styles.sliderControlButton}
        aria-label={!isArabic ? 'Scroll left' : 'Scroll right'}
      >
        <Tooltip.New
          content={!isArabic ? t('Move Left') : t('Move Right')}
          wrapperClassName={styles.sliderControlTooltip}
          className='tooltipContent'
          dataAttrTooltipContent='tiers-slider-controls'
        >
          <div className={styles.navigationArrowIcon}>
            <NavigationArrowLeftIcon />
          </div>
        </Tooltip.New>
      </button>
      <button
        type='button'
        onMouseDown={() => onScroll(!isArabic ? 'right' : 'left')}
        onMouseUp={stopScrolling}
        onMouseLeave={stopScrolling}
        className={styles.sliderControlButton}
        aria-label={!isArabic ? 'Scroll right' : 'Scroll left'}
      >
        <Tooltip.New
          content={!isArabic ? t('Move Right') : t('Move Left')}
          wrapperClassName={styles.sliderControlTooltip}
          className='tooltipContent'
          dataAttrTooltipContent='tiers-slider-controls'
        >
          <div className={styles.navigationArrowIcon}>
            <NavigationArrowRightIcon />
          </div>
        </Tooltip.New>
      </button>
    </nav>
  )
}
